/* unplugin-vue-components disabled */import { render } from "./formItem.vue?vue&type=template&id=ee390578&scoped=true"
const script = {}

import "./formItem.vue?vue&type=style&index=0&id=ee390578&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee390578"]])

export default __exports__